const { jitsiLocalStorage } = require('lib-js-utils/jitsi-local-storage');
const axios = require('axios');

// const domain = process.env.REACT_APP_DOMAIN || 'https://gagl-api.comrex.com/api';
const domain = process.env.REACT_APP_DOMAIN || 'https://comrex-api-dev.panthermediasystem.net/api';
// const domain = process.env.REACT_APP_DOMAIN || 'http://localhost:3000/api';


export const axiosInstance = axios.create({
    baseURL: domain,
    headers: {
        'Content-Type': 'application/json'
    }
});

axiosInstance.interceptors.request.use(config => {
    const accessToken = jitsiLocalStorage.getItem('auth_token');

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
});

const refreshToken = () => {
    const rfToken = jitsiLocalStorage.getItem('refreshToken');

    if (!rfToken) {
        return;
    }

    return axiosInstance.get(`/auth/refresh-token/${rfToken}`);

};

axiosInstance.interceptors.response.use(response => response, async error => {
    const config = error.config;

    if (error.response && error.response.status === 401) {
        try {
            const res = await refreshToken().then(resp => resp.data);


            if (res?.accessToken) {
                jitsiLocalStorage.setItem('auth_token', res.accessToken);

                jitsiLocalStorage.setItem('refreshToken', res?.refreshToken);
            }

            return axiosInstance(config);

        } catch {
            jitsiLocalStorage.removeItem('refreshToken');
            jitsiLocalStorage.removeItem('auth_token');
            window.location.reload();
        }
    }

    return Promise.reject(error);
});
